import React from "react";
import styles from "./Loading.module.scss";
import loadingIcon from "../../../assets/images/np_loading.png";
import ajaxLoader from "../../../assets/images/ajax-loader.gif";

const Loading = props => {

  return <div className={`${styles.loadingCont} ${props.className ? props.className : ''}`}>
    {props.type && props.type === 'ajax' ?
      <img src={ajaxLoader} alt={"loading"}/>
      : <img src={loadingIcon} alt={"loading"} className={styles.spinner}/>}
    {typeof props.label === 'undefined' || props.label ? <div>Loading...</div> : null}
  </div>;
}

export default Loading;
